import { useQuery } from "@tanstack/react-query";
import { statsOptions } from "../lib/queries";
import "./StatsSection.scss";

export default function StatsSection() {
  const { data: stats, isLoading: loading } = useQuery(statsOptions());

  const formatNumber = (num: number): string => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + "K";
    }
    return num.toString();
  };

  const formatScanTime = (ms: number): string => {
    if (ms >= 1000) {
      return (ms / 1000).toFixed(2) + "s";
    }
    return ms.toFixed(2) + "ms";
  };

  return (
    <div className="stats-section">
      <div className="stats-item">
        <div className="title-icon">
          <p className="stats-title">Files Analyzed</p>
          <img src="/file-icon.svg" alt="file" />
        </div>
        <h3 className="stats-number">
          {loading ? "Loading..." : formatNumber(stats?.total_files || 0)}
        </h3>
        <p className="stats-text">Total uploads</p>
      </div>
      <div className="stats-item">
        <div className="title-icon">
          <p className="stats-title">Scan time</p>
          <img src="/clock-icon.svg" alt="clock" />
        </div>
        <h3 className="stats-number">
          {loading
            ? "Loading..."
            : formatScanTime(stats?.median_scan_time_per_mb || 0)}
        </h3>
        <p className="stats-text">Per MB</p>
      </div>
      <div className="stats-item">
        <div className="title-icon">
          <p className="stats-title">High risk</p>
          <img src="/chart-icon.svg" alt="chart" />
        </div>
        <h3 className="stats-number">
          {loading
            ? "Loading..."
            : (stats?.high_risk_percentage || 0).toFixed(1)}
          %
        </h3>
        <p className="stats-text">Files detected</p>
      </div>
    </div>
  );
}
